"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listMyAbsenceHistoryApiPayloadSchema = exports.listAbsenceHistoryApiPayloadSchema = exports.absenceHistoryPeriodApiPayloadSchema = exports.listAbsenceHistoryApiResponseSchema = exports.absenceHistoryItemApiResponseSchema = void 0;
const zod_1 = require("zod");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const absence_enums_1 = require("./absence-enums");
const absence_queue_1 = require("./absence-queue");
exports.absenceHistoryItemApiResponseSchema = absence_queue_1.assistantAbsenceRequestApiResponseSchema;
exports.listAbsenceHistoryApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.absenceHistoryItemApiResponseSchema).extend({
    /** Total number of matching absences, all pages combined. */
    total: zod_1.z.number(),
});
const arrayFromMaybeString = (schema) => zod_1.z.preprocess((value) => value === undefined || value === null
    ? undefined
    : Array.isArray(value)
        ? value
        : [value], zod_1.z.array(schema).optional());
const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
exports.absenceHistoryPeriodApiPayloadSchema = zod_1.z.object({
    from: zod_1.z.string().regex(DATE_ONLY_PATTERN),
    to: zod_1.z.string().regex(DATE_ONLY_PATTERN),
});
exports.listAbsenceHistoryApiPayloadSchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1),
    per_page: zod_1.z.coerce.number().int().min(1),
    search: zod_1.z.string().optional(),
    assistantId: zod_1.z.string().uuid().optional(),
    types: arrayFromMaybeString(absence_enums_1.absenceTypeSchema),
    statuses: arrayFromMaybeString(absence_enums_1.absenceStatusSchema),
    period: exports.absenceHistoryPeriodApiPayloadSchema.optional(),
});
exports.listMyAbsenceHistoryApiPayloadSchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1),
    per_page: zod_1.z.coerce.number().int().min(1),
    types: arrayFromMaybeString(absence_enums_1.absenceTypeSchema),
    statuses: arrayFromMaybeString(absence_enums_1.absenceStatusSchema),
});
